import { render, staticRenderFns } from "./rule_render.vue?vue&type=template&id=0cfddd37&scoped=true"
import script from "./rule_render.vue?vue&type=script&lang=js"
export * from "./rule_render.vue?vue&type=script&lang=js"
import style0 from "./rule_render.vue?vue&type=style&index=0&id=0cfddd37&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfddd37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cfddd37')) {
      api.createRecord('0cfddd37', component.options)
    } else {
      api.reload('0cfddd37', component.options)
    }
    module.hot.accept("./rule_render.vue?vue&type=template&id=0cfddd37&scoped=true", function () {
      api.rerender('0cfddd37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/promotion/pro_policy-copy/form/rule_render/rule_render.vue"
export default component.exports